import React from 'react';
import PropTypes from 'prop-types';

import FilterButton from '../../SharedComponents/FilterButton';
import { FILTER_VALUES, TRACKING_LABELS } from '../../constants';
import { trackEvent } from '../../../../../components/Analytics/TrackedClick';

const UpcomingEventsFilter = (props) => {
    const { filters, handleFilterUpdate } = props;
    const { UPCOMING } = FILTER_VALUES;

    const handleClick = () => {
        handleFilterUpdate({
            dateRange: UPCOMING,
            startDate: null,
            endDate: null,
            eventState: null,
        }, 'submit');

        const { UPCOMING: UPCOMING_LABEL, CLIENT, EVENT_NAME } = TRACKING_LABELS;
        trackEvent(EVENT_NAME, {
            filter_name: UPCOMING_LABEL,
            client: CLIENT,
        });
    };

    return (
        <FilterButton
            isActive={filters.dateRange === UPCOMING && !filters.eventState}
            onClick={handleClick}
            data-testid="search.events.filter.upcoming"
        >
            Upcoming
        </FilterButton>
    );
};

UpcomingEventsFilter.propTypes = {
    filters: PropTypes.instanceOf(Object).isRequired,
    handleFilterUpdate: PropTypes.func.isRequired,
};

export default UpcomingEventsFilter;
